import { TaskEvent } from '@dispatch/shared/types';
import { dispatchClient } from '../clients';

const APIM_PTQS_URL = 'dispatch/progressTrackingQuery';

export async function getTaskEventsById(
  id: string,
  pageSize = 50
): Promise<TaskEvent[] | undefined> {
  try {
    const response = await dispatchClient.get<TaskEvent[]>(
      `${APIM_PTQS_URL}/tasks/${id}/events`,
      {
        params: {
          pageSize,
        },
      }
    );

    if (response.status === 200) {
      return response.data;
    }
  } catch {
    throw new Error('Error fetching Task Events from PTQS API');
  }
  return undefined;
}
